<ng-container *transloco="let t">
    <bazis-button
        fill="clear"
        class="bazis-modal__close"
        (click)="closeModal()"
    >
        {{ t('action.close') }}
        <bazis-icon
            name="cross"
            slot="end"
        ></bazis-icon>
    </bazis-button>

    <div class="bazis-modal__content">
        @for (img of gallery(); let i = $index; track $index) {
            @if (i === currentIndex) {
                @let image = img.id | entity: img.type | async;
                @if (image) {
                    <img
                        [src]="image.$snapshot.file"
                        [alt]="imagesAlt && imagesAlt() ? imagesAlt()[i] : image.$snapshot.name"
                    />
                }
            }
        }
    </div>

    @if (currentIndex > 0) {
        <bazis-button
            fill="outline"
            class="bazis-btn-prev"
            (click)="next(-1)"
        >
            <bazis-icon
                name="angle-small-left"
                slot="icon-only"
            ></bazis-icon>
        </bazis-button>
    }

    @if (currentIndex < gallery().length - 1) {
        <bazis-button
            fill="outline"
            class="bazis-btn-next"
            (click)="next(1)"
        >
            <bazis-icon
                name="angle-small-right"
                slot="icon-only"
            ></bazis-icon>
        </bazis-button>
    }
</ng-container>
